import React from 'react'

import { ShieldCheck, HandHeart, HeartHandshake, Flame, ArrowRight } from 'lucide-react'

import ColorPallet from '../../../utils/ColorPallet'
import { useNavigate, useLocation } from 'react-router-dom'


function SecondSection() {
 const navigate = useNavigate();
 const location = useLocation();

 const handleNavigation = () => {
  navigate('/packages', { 
    state: { 
      from: location.pathname 
    } 
  });
 }

  return (
   <div className="container mx-auto px-6 pt-12 pb-14">
      {/* Our Vision */}
      <div className="pt-12">
        <h1 className="text-3xl md:text-4xl font-bold mb-14 bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text uppercase text-center">
          kenapa harus pilih papakilo academy?
        </h1>
         <p className="sm:text-xl md:text-2xl font-bold capitalize text-center" style={{ color: ColorPallet.primaryDarkBrown }}>
           Ingin menjadi barber yang tidak hanya mahir memotong rambut, tetapi juga mampu menciptakan pengalaman yang tak terlupakan bagi setiap klien? Papakilo Academy adalah jawabannya. Dengan kurikulum yang terstruktur, tenaga pengajar berpengalaman, dan fasilitas modern, kami akan membimbing Anda menjadi seorang barber yang kreatif dan inovatif.
         </p>
         <button onClick={handleNavigation} className="flex w-64
          items-center space-x-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 rounded-3xl hover:shadow-lg transform hover:scale-105 ease-in duration-300 mt-7 justify-center mx-10">
            <ShieldCheck className="w-6 h-6 animate-ping" />
            <span>Gabung Sekarang</span>
            <ArrowRight className="w-6 h-6" />
         </button>
        </div>

      {/* Our Mission */}
      <div className=" pt-32">
         <h1 className="md:text-4xl sm:text-3xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text uppercase text-center">
          Asah Bakatmu Jadi Barber Profesional di Papakilo Academy!
         </h1>
         
         {/* Informations */}
          <div className="grid sm:grid-cols-1 md:grid-cols-4 gap-4 pt-12 mb-10 pointer-events-auto">
            {/* First Point */}
           < div className="grid grid-rows-2 justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300 p-6">
              <div className="w-auto h-auto p-4 rounded-full text-white" style={{ backgroundColor: ColorPallet.secondLightBrown}}>
               <HandHeart className='w-16 h-16 animate-hand-heart'/>
              </div>
              <h1 className='md:text-lg font-semibold capitalize text-center'>
               Pendekatan Holistik
              </h1>
            </div>
            
            {/* Second Point */}
           <div className="grid grid-rows-2 justify-center justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300 p-6">
             <div className="w-auto h-auto p-4 rounded-full text-white" style={{ backgroundColor: ColorPallet.secondLightBrown}}>
              <HeartHandshake className='w-16 h-16 animate-heartbeat-shake'/>
             </div>
             <h1 className='md:text-lg font-semibold capitalize text-center'>
               Kurikulum yang Relevan
             </h1>
           </div>

          {/* Thirth Point */}
          <div className="grid grid-rows-2 justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300 p-6">
             <div className="w-auto h-auto p-4 rounded-full text-white" style={{ backgroundColor: ColorPallet.secondLightBrown}}>
              <ShieldCheck className='w-16 h-16 animate-bounce'/>
             </div>
              <h1 className='md:text-lg font-semibold text-center'>
               Jaminan Sampai Bisa
              </h1>
           </div>
            
            {/* Fourth Point */}
           <div className="grid grid-rows-2 justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300 p-6">
             <div className="w-auto h-auto p-4 rounded-full text-white" style={{ backgroundColor: ColorPallet.secondLightBrown}}>
              <Flame className='w-16 h-16 animate-fire-flicker'/>
             </div>
              <h1 className='text-xl md:text-lg font-semibold text-center'>
               Siap Untuk Bekerja
              </h1>
            </div>
          </div>

       </div>
   </div>
  )
}

export default SecondSection